if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.parentInfoWrapper = this.closest('div.product__info-container');
      this.form = this.querySelector('form');
      this.form.querySelector('[name*=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');      
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      // console.log(this.form)
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      // console.log(this.cartNotification.getSectionsToRender()) 
      this.cartNotification.getSectionsToRender().map((section) => console.log(section.id))
      // for (var value of formData.values()) {
      //   console.log(value);
      // }
      
      if(this.parentInfoWrapper) {
        let addons = this.parentInfoWrapper.querySelectorAll('.addons input[type="checkbox"]:checked');
        if (addons.length > 0) {
          for(var i=0; i<addons.length;i++) {
            formData.append('id[]', addons[i].value);
          }
        }
      }
    
      
      config.body = formData;     
      
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          this.cartNotification.renderContents(response);
          this.cartNotification.classList.remove('is-empty');
          const checkoutBtn = document.querySelector('.floating__checkout-btn');
          if (checkoutBtn) {
            checkoutBtn.classList.remove('hidden');
          }
          // run custom offers
          window.CUSTOM_OFFERS && window.CUSTOM_OFFERS.runCustomOffers();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          document.querySelector('.floating-icons .gokwik-checkout').classList.remove('hidden');
          document.querySelector('.floating-icons .gokwik-checkout button .btn-text').textContent = document.querySelector('#cart-notification-links .gokwik-checkout .btn-text').textContent;
          if(document.querySelector('.before-checkkout-addons .gokwik-checkout .btn-text')){
            document.querySelector('.before-checkkout-addons .gokwik-checkout .btn-text').textContent = document.querySelector('#cart-notification-links .gokwik-checkout .btn-text').textContent;
          }
          if(document.querySelector('#cart-notification-links .gokwik-checkout button').hasAttribute('disabled')){
            document.querySelector('.floating-icons .gokwik-checkout button').setAttribute('disabled','disabled');
            document.querySelector('.before-checkkout-addons .gokwik-checkout button').setAttribute('disabled','disabled');
          } else {
            document.querySelector('.floating-icons .gokwik-checkout button').removeAttribute('disabled');
            document.querySelector('.before-checkkout-addons .gokwik-checkout button').removeAttribute('disabled');
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}



// Pure vanilla JavaScript - no jQuery dependency
// Initialize product form functionality when DOM is ready
document.addEventListener('DOMContentLoaded', function(){
  document.addEventListener('click', function(e) {
    if (!e.target.matches('.product-form-main .product-form__submit')) return;
    
    e.preventDefault();
    const clickedButton = e.target;
    const form = clickedButton.closest('form');
    const productElement = clickedButton.closest('.product');
    
    // Get product ID and quantity
    const productIdInput = form.querySelector('input[name="id[]"]');
    const productId = productIdInput ? productIdInput.value : '';
    const quantityInput = productElement ? productElement.querySelector('.quantitymain .quantity__input') : null;
    const productQuantity = quantityInput ? quantityInput.value : '1';
    
    // Collect addon data
    const addonArray = [];
    const addons = document.querySelectorAll('.collection.addons ul li');
    
    addons.forEach(function(addon) {
      const checkedItem = addon.querySelector('input[type="checkbox"]:checked');
      if (checkedItem) {
        const qtyInput = checkedItem.previousElementSibling;
        const checkedItemQty = qtyInput ? qtyInput.value : '1';
        const checkId = checkedItem.value;
        const itemlast = checkId + '-' + checkedItemQty;
        addonArray.push(itemlast);
      }
    });

    // Prepare form data
    let formdata;
    if (addonArray.length > 0) {
      formdata = {
        items: addonArray.map(variantId => {
          const splitVra = variantId.split('-');
          const addonQty = splitVra[1];
          const addonId = splitVra[0];
          return {
            id: addonId,
            quantity: addonQty
          };
        })
      };
      
      // Add the main product to the items array
      formdata.items.push({
        id: productId,
        quantity: productQuantity
      });
    } else {
      formdata = {
        items: [
          {
            id: productId,
            quantity: productQuantity
          }
        ]
      };
    }

    // Set loading state
    clickedButton.setAttribute('aria-disabled', 'true');
    clickedButton.classList.add('loading');
    const spinner = clickedButton.querySelector('.loading-overlay__spinner');
    if (spinner) {
      spinner.classList.remove('hidden');
    }

    // Make AJAX request to add to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formdata)
    })
    .then(response => response.json())
    .then(data => {
      // Update cart notification
      const cartNotificationWrapper = document.getElementById('cart-notification-wrapper');
      if (cartNotificationWrapper) {
        cartNotificationWrapper.classList.add('active');
      }
      
      const cartNotification = document.querySelector('.cart-notification');
      if (cartNotification) {
        cartNotification.classList.add('active');
      }
      
      const cartNotificationEl = document.getElementById('cart-notification');
      if (cartNotificationEl) {
        cartNotificationEl.classList.add('cart-loading');
      }
      
      // Fetch updated cart content
      fetch('/')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Update Gokwik button text
        const btnGoSource = doc.querySelector('.gokwik-checkout .btn-text');
        const gokwikButtons = document.querySelectorAll('.gokwik-checkout .btn-text');
        if (btnGoSource) {
          gokwikButtons.forEach(btn => {
            btn.innerHTML = btnGoSource.innerHTML;
          });
        }
        
        // Enable Gokwik buttons
        const gokwikButtonEls = document.querySelectorAll('.gokwik-checkout button');
        gokwikButtonEls.forEach(btn => {
          btn.disabled = false;
        });
        
        // Update cart data
        const cartDataSource = doc.querySelector('#new_cart_wrapper');
        const cartDataTargets = document.querySelectorAll('#new_cart_wrapper');
        if (cartDataSource) {
          cartDataTargets.forEach(target => {
            target.innerHTML = cartDataSource.innerHTML;
          });
        }
        
        // Handle session storage for addons
        setTimeout(function(){
          const sessionAdd = sessionStorage.getItem('last-addon');
          // console.log(sessionAdd);
          const gokwikCheckout = document.querySelector('#cart-notification-links .gokwik-checkout');
          if (gokwikCheckout) {
            if (sessionAdd && sessionAdd === 'true') {
              gokwikCheckout.setAttribute('data-popupfirst', 'false');
            } else {
              gokwikCheckout.setAttribute('data-popupfirst', 'true');
            }
          }
        }, 2000);
        
        // Update cart count
        const cartCountSource = doc.querySelector('.cart-count-bubble > span[aria-hidden="true"]');
        const cartCountTargets = document.querySelectorAll('.cart-count-bubble > span[aria-hidden="true"]');
        if (cartCountSource) {
          cartCountTargets.forEach(target => {
            target.textContent = cartCountSource.textContent;
          });
        }
        
        // Show/hide cart elements
        const cartEmpty = document.querySelector('.cart-notification__footer cart-empty');
        if (cartEmpty) {
          cartEmpty.style.display = 'none';
        }
        
        const cartForm = document.querySelector('.cart-notification__footer #cart-notification-form');
        if (cartForm) {
          cartForm.style.display = 'block';
        }
        
        // Remove loading state from cart
        if (cartNotificationEl) {
          cartNotificationEl.classList.remove('cart-loading');
        }
      })
      .catch(error => {
        console.error('Error fetching cart content:', error);
      });
      
      // Remove loading state from button
      if (spinner) {
        spinner.classList.add('hidden');
      }
      clickedButton.classList.remove('loading');
      clickedButton.setAttribute('aria-disabled', 'false');
      
      // Show floating checkout button
      const floatingCheckout = document.querySelector('.floating-icons .gokwik-checkout');
      if (floatingCheckout) {
        floatingCheckout.classList.remove('hidden');
      }
      
      // Update floating button text
      const floatingBtnText = document.querySelector('.floating-icons .gokwik-checkout button .btn-text');
      const sourceBtnText = document.querySelector('#cart-notification-links .gokwik-checkout .btn-text');
      if (floatingBtnText && sourceBtnText) {
        floatingBtnText.textContent = sourceBtnText.textContent;
      }
      
      // Handle button disabled state
      const sourceBtn = document.querySelector('#cart-notification-links .gokwik-checkout button');
      const floatingBtn = document.querySelector('.floating-icons .gokwik-checkout button');
      if (sourceBtn && floatingBtn) {
        if (sourceBtn.hasAttribute('disabled')) {
          floatingBtn.setAttribute('disabled', 'disabled');
        } else {
          floatingBtn.removeAttribute('disabled');
        }
      }
    })
    .catch(error => {
      console.error('Cart add error:', error);
      
      // Remove loading state
      clickedButton.setAttribute('aria-disabled', 'false');
      clickedButton.classList.remove('loading');
      if (spinner) {
        spinner.classList.add('hidden');
      }
      
      // Show error message
      const errorWrapper = document.querySelector('.product-form__error-message-wrapper');
      if (errorWrapper) {
        errorWrapper.removeAttribute('hidden');
        const errorMsg = errorWrapper.querySelector('.product-form__error-message');
        if (errorMsg && error.responseJSON && error.responseJSON.description) {
          errorMsg.textContent = error.responseJSON.description;
        }
      }
    });
  });
});